import { actionCreatorFactory } from 'typescript-fsa';
import { IApiUserSettings, TApiUserSettingValue } from '@cbridge-packages/api';

export namespace UserSettingsAction {
  const actionCreator = actionCreatorFactory('USER_SETTINGS');

  /** Dispatched right after login; rendering is gated until it resolves. */
  export const load = actionCreator.async<void, IApiUserSettings>('LOAD');

  /** Optimistically merges the value into the store and triggers a debounced PATCH. */
  export const saveSetting = actionCreator<{ key: string; value: TApiUserSettingValue }>('SAVE_SETTING');

  export const save = actionCreator.async<IApiUserSettings, void>('SAVE');

  export const destroy = actionCreator('DESTROY');
}
